import { useCallback, useEffect, useState } from "react";
import MenuTop from "../../../../components/menu/top/menu-top";
import './style.css';
import { FormProps } from "../../../../shared/interfaces/form";
import Form from "../../../../components/form/form";
import { useAlert } from "../../../../components/alert/alert";
import { SEVERITY } from "../../../../shared/interfaces/alert";
import { useNavigate, useParams } from 'react-router-dom';
import { fetchUserService, updateUserService, deleteUserService } from "../../../../features/users/service/users-service";
import { fetchRolesWithoutAdmin } from "../../../../shared/services/roles";
import userData from "../../../../features/users/forms/user-data";
import Breadcrumb from "../../../../components/breadcrumb/breadcrumb";
import storage from "../../../../shared/services/storage";
import { fetchCompaniesService as getCompanies } from "../../../../features/company/service/company";
import InfoComponent from "../../../../components/info/info";
import { CustomModal, useModal } from "../../../../components/modals/common/index";
import { Typography } from "@mui/material";

export function EditUser() {
    const { id } = useParams();
    const { showAlert } = useAlert();
    const navigate = useNavigate();
    const [formData, setFormData] = useState<FormProps[] | undefined>();
    
    // Hook para controlar o estado da modal de confirmação de exclusão
    const deleteModal = useModal();

    const handleEditUser = async (formData: any) => {
        if(id && formData) {
          const response = await updateUserService(id, formData);

          if(response) {
            showAlert('Usuário editado com sucesso', SEVERITY.SUCCESS);
            navigate('/usuarios');
          }
        }
    };
    
    // Função para lidar com a exclusão do usuário
    const handleDeleteUser = async () => {
        if (id) {
            try {
                await deleteUserService(id);
                showAlert('Usuário excluído com sucesso', SEVERITY.SUCCESS);
                navigate('/usuarios');
            } catch (error) {
                console.error('Erro ao excluir usuário:', error);
                showAlert('Erro ao excluir usuário', SEVERITY.ERROR);
            }
        }
    };

    const fetchRolesData = useCallback(async () => {
        try {
            const roles = await fetchRolesWithoutAdmin();
            const rolesOptions = roles?.map(({ name, id}: any) => ({ label: name, value: id }));

            return rolesOptions;
        } catch (error) {
            console.log(error);
        }
    }, []);

    const fetchUserData = useCallback(async (id: string) => { 
        try {
            const response = await fetchUserService(id);
            const rolesOptions = await fetchRolesData();
            const companies = await getCompanies();
            const user = JSON.parse(storage.getStorage('user') || '');
            const isMaster = user?.name.toLowerCase() === 'cauane';

            const data = userData(id, response, rolesOptions, isMaster, companies);
            setFormData(data);
        } catch (error) {
            console.log(error);
        }
    }, [fetchRolesData]); 

    useEffect(() => {
        if (id) fetchUserData(id);
        fetchRolesData();
    }, [fetchUserData, fetchRolesData, id]);

    return (
        <div className="container-client">
            <MenuTop />
            <div className='container-client__content'>
                <Breadcrumb links={['Usuários', 'Editar usuário']} href={['/usuarios', '']} />
                {formData && (
                    <>
                        <InfoComponent />
                        <Form
                            data={formData}
                            onSubmitForm={handleEditUser}
                            onCancel={() => navigate('/usuarios')}
                            title={`Editar usuário`}
                            showDeleteIcon={true}
                            onClickedMenuContextType={(type: string) => {
                                // Verifica se o tipo clicado é 'delete' e abre a modal
                                if (type === 'delete') {
                                    deleteModal.openModal();
                                }
                            }}
                        />
                    </>
                )}
                
                {/* Modal de confirmação de exclusão */}
                <CustomModal
                    open={deleteModal.isOpen}
                    onClose={deleteModal.closeModal}
                    title="Confirmar exclusão"
                    content={
                        <Typography>
                            Tem certeza que deseja excluir este usuário? Esta ação não pode ser desfeita.
                        </Typography>
                    }
                    buttons={[
                        {
                            id: 'cancel',
                            label: 'Cancelar',
                            variant: 'outlined',
                            color: 'primary',
                            onClick: deleteModal.closeModal
                        },
                        {
                            id: 'confirm',
                            label: 'Excluir',
                            variant: 'contained',
                            color: 'error',
                            onClick: () => {
                                handleDeleteUser();
                                deleteModal.closeModal();
                            }
                        }
                    ]}
                />
            </div>
        </div>
    );
}